import {useMutation} from "@tanstack/react-query";

import {addSupplierFunctionMutationOptions} from "./add-supplier-function.mutation-options";

export function useAddSupplierFunction(supplierId: string) {
  return useMutation(addSupplierFunctionMutationOptions(supplierId));
}
